export { default as Tabs } from "./Tabs";
export { Tab } from "./Tabs";
